module.exports = __webpack_public_path__ + "img/PRNT_03_mono_AE_00002.ea2a683d.png";